module.exports = __webpack_public_path__ + "assets/img/dzh-1.c9b55b55.gif";